import Model from '../../ModelBinding/Model';
import MissionStatusCollection from './MissionStatusCollection';
import dayjs from 'dayjs';
import AvailableEventCollection from '../AvailableEvent/AvailableEventCollection';
export default class MissionStatus extends Model {
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public events?: AvailableEventCollection;

  static rootUri = 'missions/status';

  bind() {
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.events = this.getRelationCollection(
      'events',
      AvailableEventCollection,
    ) as AvailableEventCollection;
  }

  static getCollection() {
    return MissionStatusCollection;
  }
}
